var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-profile-inge';
                    var viewUrl = 'sprite.svg#view-icon-profile-inge';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 79 56',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };